<sbnb-icon [icon]="white ? 'airbnb-white' : 'airbnb'" [size]="size" [class.icon-platform-muted]="muted"></sbnb-icon>
